import { Card, Typography } from '@globalmed/atlas-ui';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { NotificationItem } from '../NotificationItem';
import styles from './NotificationsBody.module.css';
import { useNotificationsStore } from '@/stores/notifications';

type TProps = {
  onClose: () => void;
};

const NotificationsBody = ({ onClose }: TProps) => {
  const { t } = useTranslation();
  const notifications = useNotificationsStore((state) =>
    state.getAppointmentNotifications(),
  );
  const sortNotifications = notifications.sort(
    (a, b) => dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf(),
  );
  return (
    <div className={styles.body}>
      {sortNotifications?.length === 0 ? (
        <Card variant="outlined">
          <Typography
            color={'var(--colors-gray600)'}
            sx={{ lineHeight: '20px', fontWeight: '400', textAlign: 'center' }}
          >
            {t('no-notifications-received')}
          </Typography>
        </Card>
      ) : (
        sortNotifications.map((item) => (
          <NotificationItem
            key={item.id}
            onClose={onClose}
            notification={item}
          />
        ))
      )}
    </div>
  );
};

export { NotificationsBody };
